"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  name: "Emily R.",
  role: "Winter Park Residence",
  content: "The attention to detail is remarkable. My home feels peaceful and pristine after every single visit.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623166/img/testimonial_avatar_emily.png"
}, {
  name: "Sarah M.",
  role: "Baldwin Park",
  content: "A cleaning service that truly understands the nuances of a premium home. Simply outstanding.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623166/img/testimonial_avatar_sarah.png"
}, {
  name: "Winter Park Client",
  role: "Local Property Owner",
  content: "Exceptional service with a professional touch. A true local gem for our residence.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623166/img/testimonial_avatar_winterpark_illus.png"
}, {
  name: "J. Liu",
  role: "Lake Nona",
  content: "Efficient, thorough, and incredibly professional. They transformed our space in record time.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623166/img/testimonial_avatar_liu.png"
}, {
  name: "Orlando Homeowner",
  role: "Pet-Friendly Household",
  content: "Even our golden retriever loves when the team visits! They are so careful and thorough with every room.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623166/img/testimonial_avatar_pet_friendly.png"
}];
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="9659" id="local-experiences" ref={ref} className="bg-background py-40 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-30" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-30" />

      <div className={cn("container mx-auto px-6 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="text-center mb-20 max-w-3xl mx-auto">
          <h2 className="font-default text-4xl md:text-5xl text-foreground mb-6 tracking-tight">
            Local Experiences
          </h2>
          <p className="font-default text-muted-foreground text-lg font-light tracking-wide">
            Thoughtful care for the spaces you call home. Experience the quiet luxury of a perfectly curated and pristine environment.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-4 md:-ml-8">
            {testimonials.map((testimonial, index) => <CarouselItem key={index} data-index={index} className="pl-4 md:pl-8 basis-1/3">
                <div className="h-full p-1">
                  <Card className="h-full bg-transparent border-0 shadow-none rounded-none p-0 group">
                    <CardContent className="p-10 flex flex-col h-full justify-between gap-8">
                      <div>
                        <div className="mb-6 text-primary opacity-60">
                          <Quote strokeWidth={1} size={40} />
                        </div>
                        <blockquote className="font-serif text-xl text-foreground/90 leading-relaxed italic">
                          &quot;{testimonial.content}&quot;
                        </blockquote>
                      </div>

                      <div className="pt-6 border-t border-border/10">
                        <div>
                          <div className="font-default font-semibold text-foreground text-sm tracking-wide uppercase">
                            {testimonial.name}
                          </div>
                          <div className="font-default text-muted-foreground text-xs tracking-wider mt-0.5">
                            {testimonial.role}
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          <div className="flex justify-center gap-4 mt-16">
            <CarouselPrevious variant="outline" className="static translate-y-0 translate-x-0 h-12 w-12 rounded-none border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors duration-300" />
            <CarouselNext variant="outline" className="static translate-y-0 translate-x-0 h-12 w-12 rounded-none border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors duration-300" />
          </div>
        </Carousel>
      </div>
    </section>;
}